import styled from "styled-components";
import {
  AccordionDetails,
  AccordionSummary,
  alpha,
  Box,
  Button,
  Typography,
} from "@mui/material";

export const Container = styled(Box)(({ theme }) => ({
  position: "fixed",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "#1b1b1b  !important",
}));

export const MessageContainer = styled(Box)(({ theme }) => ({
  background: alpha(theme.palette.background.default, 0.95),
  border: `${theme.spacing(0.4)} solid #F43E63`,
  boxShadow: `0 0 1rem 0rem ${alpha("#F43E63", 0.95)}, 0 0 2rem 0.25rem ${alpha("#1B1B1B", 0.95)}`,
  backdropFilter: "blur(20px)",
  backgroundColor: alpha("#FFFFFF", 0.1),
  borderRadius: theme.spacing(1),
  height: "fit-content",
  padding: `1rem 2.5rem 1.5rem 2.5rem`,
  maxWidth: "600px",

  [theme.breakpoints.down("sm")]: {
    padding: `1rem 1.5rem 1.5rem 1.5rem`,
    maxWidth: "80vw",
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: "2.2rem !important",

  [theme.breakpoints.down("sm")]: {
    fontSize: "1.5rem !important",
  },
}));

export const Description = styled(Typography)(({ theme }) => ({
  fontSize: "1.5rem !important",

  [theme.breakpoints.down("sm")]: {
    fontSize: "1rem !important",
  },
}));

export const IconContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
}));

export const BackCta = styled(Button)(({ theme }) => ({
  borderRadius: "8px",
  padding: "8px 16px",
  color: "rgb(21, 21, 21) !important",
  backgroundColor: "rgb(244, 62, 99) !important",
  textTransform: "none",
  fontWeight: "600",
  fontSize: "1rem",
  "&:hover": {
    backgroundColor: "rgba(244, 62, 99, 0.9) !important",
    boxShadow:
      "rgba(0, 0, 0, 0.2) 0px 2px 4px -1px, rgba(0, 0, 0, 0.14) 0px 4px 5px 0px, rgba(0, 0, 0, 0.12) 0px 1px 10px 0px",
  },
}));

export const IssueContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  borderRadius: "4px",
  overflow: "hidden",
  backgroundColor: "#1B1B1B !important",
}));

export const IssueSummary = styled(AccordionSummary)(({ theme }) => ({
  backgroundColor: "#1B1B1B !important",
  color: "white !important",
  textAlign: "start",
}));

export const IssueDetails = styled(AccordionDetails)(({ theme }) => ({
  backgroundColor: "#1B1B1B !important",
  color: "white !important",
  textAlign: "start",
}));
